export var ContainerDefaultProps = {
    as: 'div',
    margeExterne: true,
};
export var RowDefaultProps = {
    goutierre: false,
    alignementHorizontal: 'left',
    alignementVertical: 'top',
};
